var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DateTime } from 'luxon';
import { useState } from 'react';
import { useDrawer } from '#context';
import { usePlugFilespaceClient } from '#query-hooks';
import { GuestLinkKeyFactory } from '../query-key-factories/GuestLinkKeyFactory';
const CREATE_GUEST_LINK_MUTATION_KEY_PREFIX = 'create-guest-link';
export const useCreateGuestLink = () => {
    _react_refresh_temp_1();
    const queryClient = useQueryClient();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const { openDrawer } = useDrawer();
    const [mutationKey, setMutationKey] = useState(generateMutationKey);
    const mutation = useMutation({
        mutationKey: [mutationKey],
        mutationFn: async (params) => {
            return plugFilespaceClient({
                action: (fsClient) => fsClient.guestLinksManagement().createGuestLink({
                    ...params,
                    name: `Untitled [${DateTime.now().toLocaleString(DateTime.DATETIME_FULL_WITH_SECONDS)}]`,
                }),
                filespaceId: params.filespaceId,
                workspaceId: params.workspaceId,
            });
        },
        onMutate: (variables, { mutationKey: contextMutationKey }) => {
            openDrawer({
                type: 'createGuestLink',
                creationMutationKey: contextMutationKey?.at(0)?.toString() ?? mutationKey,
                ...variables,
            });
        },
        onSuccess: async (data, variables) => {
            openDrawer({
                type: 'manageGuestLinks',
                guestLinkId: data.linkId,
                ...variables,
            });
            await queryClient.refetchQueries({
                queryKey: GuestLinkKeyFactory.all(variables),
            });
        },
        onSettled: () => {
            setMutationKey(generateMutationKey());
        },
    });
    return { mutation };
};
_react_refresh_temp_1(useCreateGuestLink, "rLsDGIEcfTptYgNzlBSYdQzmpMk=", false, () => [useQueryClient, usePlugFilespaceClient, useDrawer, useMutation]);
const generateMutationKey = () => `${CREATE_GUEST_LINK_MUTATION_KEY_PREFIX}-${Date.now()}`;
